/**
 * Input Schema of CargaDestinatario
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaDestinatario} from '@/model/resource/CargaDestinatario'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {EnderecoCollection} from '@/model/collection/EnderecoCollection'

/* TODO: review generated schema */
export class InputCargaDestinatarioSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()
  collectionEndereco = new EnderecoCollection().noPagination()

  readonly name = 'InputCargaDestinatario'

  readonly fieldSet: FieldSet<CargaDestinatario> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    endereco: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionEndereco.all(),
      },
    }),
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    cpfCnpj: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 21,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    telefone: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'phone',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required|phone',
      },
    }),
    indicadorIe: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 511,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    inscricaoEstadual: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    inscricaoSuframa: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    im: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
      },
    }),
    email: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'email',
        label: this.translateFrom(schema.fieldName),
        validation: 'email',
      },
    }),
  }
}
